import { createApi } from '@reduxjs/toolkit/query/react';

import { apiWeeklyPlannerAppointments } from '~constants/api';

import { Response, rtkBaseQueryWrapper } from '~libs/axiosWrapper';
import { UnallocatedAppointment } from '~weekly-planner/lib/common';

import { typePrefix as prefix } from '~weekly-planner/actions/appointments';

export const typePrefix = `${prefix}-bulk-assignees`;

interface BulkAssigneesReq {
  ignoreAvailability: boolean;
  ignoreQualified: boolean;
  week_start: string;
  week_end: string;
}

export const bulkAssigneesApi = createApi({
  reducerPath: 'weeklyPlannerBulkAssigneesApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiWeeklyPlannerAppointments }),
  endpoints: (builder) => ({
    getBulkAssignees: builder.query<Response<UnallocatedAppointment[]>, BulkAssigneesReq>({
      query: (params) => ({ url: '/bulk-assignees', method: 'GET', params }),
    }),
  }),
});

export const { useLazyGetBulkAssigneesQuery } = bulkAssigneesApi;
